/**
 * TanStack Query hooks for `appsflyer-network-postback-installs-in-app-events`.
 * Thin wrappers over ./api. No raw fetch here.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	postbackEventsQueryKeys,
	type CreatePostbackEventBody,
	type CreatePostbackEventResponse,
	type ListPostbackEventsResponse,
	type ListQueryParams,
} from "./api";

export function usePostbackEventsList(
	params: ListQueryParams = {},
): UseQueryResult<ListPostbackEventsResponse, Error> {
	return useQuery({
		queryKey: postbackEventsQueryKeys.list(params),
		queryFn: () => list(params),
	});
}

export function usePostbackEventCreate(): UseMutationResult<
	CreatePostbackEventResponse,
	Error,
	CreatePostbackEventBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: postbackEventsQueryKeys.all });
		},
	});
}
